import { Component, OnInit } from '@angular/core';
import { ClienteService } from '../api/cliente-service.service';
import { UsuarioService } from '../api/usuario.service';
import {
  ActionSheetController,
  IonicModule,
  LoadingController,
  ModalController,
} from '@ionic/angular';
import { MeusClientesEdicaoPage } from '../meus-clientes-edicao/meus-clientes-edicao.page';
import { Subject } from 'rxjs';
import { MembroClienteEdicaoPage } from '../membro-cliente-edicao/membro-cliente-edicao.page';
import { AssinaturaService } from '../api/assinatura.service';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { AssinaturaComponent } from '../assinatura/assinatura.component';
import { Share } from '@capacitor/share';

@Component({
  selector: 'app-meus-clientes',
  templateUrl: './meus-clientes.page.html',
  styleUrls: ['./meus-clientes.page.scss'],
  imports: [IonicModule, NgIf, NgFor, AssinaturaComponent, DatePipe],
})
export class MeusClientesPage implements OnInit {
  clienteLista: any = [];
  plano: unknown;
  clienteListaBkp: any;
  constructor(
    private loadingController: LoadingController,
    private clienteService: ClienteService,
    private assinaturaService: AssinaturaService,
    private modalController: ModalController,
    private usuarioService: UsuarioService,
    public actionSheetController: ActionSheetController,
  ) {}
  ngOnInit() {
    this.carregarLista();
  }

  deletarMembro(membro: any) {
    if (confirm('Deseja realmente remover o membro ' + membro.Nome + '?')) {
      this.clienteService.deletarMembro(membro).then((data: any) => {
        this.carregarLista();
      });
    }
  }
  async carregarLista() {
    const loading = await this.loadingController.create({
      message: 'Carregando...',
      spinner: 'dots',
      translucent: true,
    });
    await loading.present();

    this.usuarioService
      .obterPlano(this.usuarioService.get().Id)
      .then((data) => {
        this.plano = data;
        if (!this.plano)
          this.assinaturaService.inicializar(this.usuarioService.get());
      })
      .finally(() => {});

    this.clienteService
      .listarPorUsuarioAdmin(this.usuarioService.get().Id)
      .then((data: any) => {
        this.clienteLista = data.sort((a: any, b: any) =>
          a.Nome.localeCompare(b.Nome),
        );
        this.clienteLista.map((item) => {
          item.DataFormatada = new Date(item.Data).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
          });
          item.DataAlteracaoFormatada = item.DataFormatada;
          if (item.DataAlteracao) {
            item.DataAlteracaoFormatada = new Date(
              item.DataAlteracao,
            ).toLocaleDateString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
            });
          }
        });
        this.clienteListaBkp = this.clienteLista;
      })
      .finally(() => {
        loading.dismiss();
      });
  }
  async alterarMembro(cliente: any, membro: any) {
    var subject = new Subject<any>();
    subject.subscribe((data: any) => {
      this.carregarLista();
    });
    const modal = await this.modalController.create({
      component: MembroClienteEdicaoPage,
      cssClass: 'modal-pontuacao',
      componentProps: {
        cliente,
        objEdicao: membro,
        subject,
      },
    });

    return await modal.present();
  }

  getItemAutocomplete(ev: any) {
    if (ev.target.value.length >= 1) {
      const val = ev.target.value;
      if (val && val.trim() !== '') {
        this.clienteLista = this.clienteListaBkp.filter((item) => {
          return item.Nome.toLowerCase().indexOf(val.toLowerCase()) > -1;
        });
      }
    } else {
      this.clienteLista = this.clienteListaBkp.sort((a: any, b: any) =>
        a.Nome.localeCompare(b.Nome),
      ); // Reordenar a lista completa quando o campo de busca estiver vazio
    }
  }

  imprimirAnotacao(cliente) {
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(
      '<html><head><title>Anotações' + cliente.Nome + '</title>',
    );

    // Optional: Include Quill's CSS for correct styling in the printout
    // Replace with the correct path to your Quill CSS file
    printWindow.document.write(
      '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@2.0.2/dist/quill.snow.css">',
    );

    printWindow.document.write('</head><body>');
    printWindow.document.write(
      '<div class="ql-editor" style="overflow: hidden; height: auto">',
    ); // Use ql-editor class for styling
    printWindow.document.write(cliente.Anotacoes);
    printWindow.document.write('</div>');
    printWindow.document.write('</body></html>');
    printWindow.document.close();

    // Wait for content to render, then print
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 100);
  }
  async cadastrarClienteClick(cliente: any) {
    var subject = new Subject<any>();
    subject.subscribe((data: any) => {
      this.carregarLista();
    });
    const modal = await this.modalController.create({
      component: MeusClientesEdicaoPage,
      cssClass: 'modal-pontuacao',
      componentProps: {
        objEdicao: cliente,
        subject,
      },
    });

    return await modal.present();
  }
  shareClientes(cliente) {
    var texto = `link de acesso para o cliente:${cliente.Nome}`;
    var link = `https://app.legislapp.com.br/#/cliente-edicao/${cliente.Id}`;
    Share.share({
      title: 'Dá uma olhada nesse cliente',
      text: texto,
      url: link,
      dialogTitle: 'Compartilhe o legislativo onde quiser!',
    });
  }
  async clienteClick(cliente) {
    const actionSheet = await this.actionSheetController.create({
      header: cliente.Nome,
      cssClass: '',
      buttons: [
        // {
        //   text: 'Adicionar Membros',
        //   icon: 'person-add-outline',
        //   handler: async () => {
        //     this.clienteClick(cliente);
        //   },
        // },
        {
          text: 'Editar Cliente',
          icon: 'pencil',
          handler: () => {
            this.cadastrarClienteClick(cliente);
          },
        },
        {
          text: 'Deletar',
          role: 'destructive',
          icon: 'trash',
          handler: async () => {
            if (
              confirm(
                'Deseja realmente remover o cliente ' + cliente.Nome + '?',
              )
            ) {
              const loading = await this.loadingController.create({
                message: 'Carregando...',
                spinner: 'dots',
                translucent: true,
              });
              await loading.present();
              this.clienteService
                .deletarCliente(cliente.Id)
                .then((data: any) => {
                  this.carregarLista();
                })
                .finally(() => {
                  loading.dismiss();
                });
            }
          },
        },
        {
          text: 'compartilhar',
          icon: 'share-social-outline',
          handler: () => {
            this.shareClientes(cliente);
          },
        },
        {
          text: 'Cancelar',
          icon: 'close',
          role: 'cancel',
          handler: () => {},
        },
      ],
    });
    await actionSheet.present();
  }

  fechar() {
    this.modalController.dismiss({});
  }
}
